
import { defineComponent } from 'vue';
import proposalsService from '@/services/proposals.service';
import { ProposalChangelogEntry } from '@/model/proposal-changelog';

interface ProposalChangelogModalState {
  entries: ProposalChangelogEntry[];
  isLoading: boolean;
}

export default defineComponent({
  name: "ProposalChangelogModal",
  props: {
    proposalId: {
      type: String,
      required: true
    }
  },
  data(): ProposalChangelogModalState {
    return {
      entries: [],
      isLoading: true
    }
  },
  mounted() {
    proposalsService
        .getChangelog(this.proposalId)
        .then(({data}) => this.entries = data.entries)
        .finally(() => this.isLoading = false);
  },
  methods: {
    statusLabel(status: string): string {
      const key = `proposal.status.${status}`;

      return this.$te(key) ? this.$t(key) : status;
    },
    formatTimestamp(value: string): string {
      return new Date(value).toLocaleString();
    },
    formatDate(value: string | null): string {
      return value ? new Date(value).toLocaleDateString() : '—';
    }
  }
})
